// Single source of truth — content sourced from the Kotam Projects brief PDF.

export const COMPANY = {
  name: "Kotam Projects",
  director: "Dilraj Grewal",
  phone: "0478 900 097",
  phoneRaw: "0478900097",
  email: "Kotamprojects@gmail.com",
  offices: [
    { state: "Victoria", label: "Victoria Office", address: "5/10 Nova Court, Craigieburn VIC 3064" },
    { state: "South Australia", label: "South Australia Office", address: "839–841 Main North Rd, Pooraka SA 5095" },
  ],
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 5:00 PM" },
    { day: "Saturday", time: "9:00 AM – 1:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const IMAGES = {
  heroMain: "/hero-house.jpg",
  heroAlt: "/home1.jpg",
  homeExterior: "/residential-home.jpg",
  facade: "/home3.webp",
  facade2: "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facade3: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interior1: "/interior-living.jpg",
  interior2: "/home1.jpg",
  interior3: "https://images.pexels.com/photos/20705883/pexels-photo-20705883.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  crane1: "https://images.unsplash.com/photo-1429497419816-9ca5cfb4571a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  crane2: "https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  commercial: "https://images.pexels.com/photos/36429815/pexels-photo-36429815.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  rebar: "https://images.unsplash.com/photo-1530863506128-dc9eb5c3e0fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  concreteDetail: "https://images.unsplash.com/photo-1586871608370-4adee64d1794?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  concreteStruct: "https://images.unsplash.com/photo-1559763194-521eef49b386?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blueprint1: "https://images.unsplash.com/photo-1772442198624-4fc4d7281e89?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blueprint2: "https://images.unsplash.com/photo-1772442198689-af331f8f9617?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  worker: "https://images.unsplash.com/photo-1758574697284-8e84046a45ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aerial: "https://images.unsplash.com/photo-1571979622878-622d38ec238c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

export const MISSION =
  "At Kotam Projects, our mission is to deliver exceptional construction solutions through quality craftsmanship, honest communication, and meticulous attention to detail. We are committed to building spaces that exceed expectations while maintaining the highest standards of safety, professionalism, and reliability. Every project is approached with integrity, ensuring our clients receive outstanding results delivered on time and within budget.";

export const VISION =
  "Our vision is to become one of Australia's most trusted and respected construction companies, recognised for delivering innovative, high-quality projects that stand the test of time. We strive to build lasting relationships with our clients, partners, and communities while continuously raising the standard of excellence within the construction industry.";

export const QUALITY =
  "Quality is the foundation of every project we undertake. From the initial planning stages through to final handover, Kotam Projects maintains rigorous quality control processes to ensure every detail meets our exacting standards. We work alongside trusted suppliers, skilled tradespeople, and experienced project managers to deliver exceptional results that provide lasting value for our clients.";

export const SAFETY =
  "Safety is more than a requirement—it's part of our culture. We are committed to maintaining safe work environments through proactive planning, ongoing training, strict compliance with Australian safety regulations, and continuous risk management. Every member of our team shares the responsibility of ensuring each project is completed safely and efficiently without compromising quality.";

export const MEANING_OF_KOTAM = [
  {
    lang: "Gilaki / Persian — كتام",
    text: "A hut-like shelter raised on the farmland to protect the farmers from the sun and rain, a sort of northern Iranian Cabana. This word is used in many places in northern Iran and adjacent areas.",
  },
  {
    lang: "Sanskrit — कोट्ट (Kotta)",
    text: "In the ancient language Sanskrit, Kotta means a stronghold, and it also means fort.",
  },
];

export const CORE_VALUES = [
  { title: "Integrity", text: "We believe trust is earned through honesty, transparency, and accountability in everything we do." },
  { title: "Excellence", text: "Every project reflects our commitment to superior workmanship, attention to detail, and uncompromising quality." },
  { title: "Safety", text: "The wellbeing of our team, clients, and contractors is our highest priority, with safety embedded into every stage of our work." },
  { title: "Collaboration", text: "Strong relationships and open communication allow us to achieve successful outcomes together." },
  { title: "Reliability", text: "We honour our commitments by delivering projects on schedule, within budget, and to the highest professional standards." },
];

export const WHY_CHOOSE = [
  { title: "Proven Experience", text: "With years of industry expertise, we deliver projects with confidence, precision, and professionalism." },
  { title: "Quality Without Compromise", text: "We use trusted materials, skilled trades, and proven construction methods to achieve exceptional results." },
  { title: "Transparent Communication", text: "We keep clients informed throughout every stage of the project, providing clarity and confidence from start to finish." },
  { title: "On-Time & On Budget", text: "Our disciplined project management ensures efficient delivery without compromising workmanship." },
  { title: "Client-Focused Approach", text: "Every project is tailored to meet the unique goals, requirements, and vision of our clients." },
  { title: "Trusted Construction Partner", text: "From planning and design through to completion, we build lasting relationships based on trust, reliability, and outstanding service." },
];

export const PARTNERS = [
  { name: "Samsung", logo: "/samsung-logo.webp" },
  { name: "Southern Star", logo: "/southern-star-logo.png" },
  { name: "Statesman Windows", logo: "/statesman-logo.png" },
  { name: "Westinghouse", logo: "/westinghouse-logo.png" },
  { name: "Caroma", logo: "/caroma-logo.png" },
  { name: "Cefito", logo: "/cefito-logo.png" },
  { name: "Daikin", logo: "/daikin-logo.png" },
];

export const SERVICES = [
  {
    slug: "residential-construction",
    title: "Residential Construction",
    tagline: "Custom homes built to last",
    overview:
      "From bespoke family homes to premium residences, we craft living spaces that balance architectural elegance with everyday functionality. Every home is delivered with meticulous attention to detail and enduring quality.",
    image: "homeExterior",
    benefits: [
      "Fully custom, architect-led builds",
      "Premium materials and trusted trades",
      "Transparent fixed-price contracts",
      "Rigorous quality assurance at every stage",
    ],
  },
  {
    slug: "renovations-extensions",
    title: "Renovations & Extensions",
    tagline: "Transform and expand",
    overview:
      "Reimagine your existing space with renovations and extensions that add value, light, and liveability. We blend new work seamlessly with the old, respecting the character of your property.",
    image: "interior1",
    benefits: [
      "Seamless integration with existing structures",
      "Minimal disruption, maximum precision",
      "Premium finishes and fit-outs",
      "Clear communication throughout",
    ],
  },
  {
    slug: "design-project-management",
    title: "Design & Project Management",
    tagline: "One trusted partner, start to finish",
    overview:
      "From the first concept sketch to the final handover, our design and project management service gives you a single, accountable point of contact. We coordinate every discipline so your vision is realised without compromise.",
    image: "blueprint1",
    benefits: [
      "Single point of accountability",
      "Coordinated consultants and trades",
      "Proactive risk and budget management",
      "Clear reporting and milestones",
    ],
  },
];

export const PROCESS = [
  { step: "01", title: "Consultation", text: "We listen first. Understanding your vision, goals, budget, and site sets the foundation for everything that follows." },
  { step: "02", title: "Planning", text: "Detailed design, documentation, and programming translate your ideas into a clear, buildable roadmap." },
  { step: "03", title: "Quotation", text: "A transparent, fixed-scope quotation with no hidden surprises, so you can proceed with complete confidence." },
  { step: "04", title: "Construction", text: "Skilled trades and disciplined site management bring the plans to life with precision and craftsmanship." },
  { step: "05", title: "Quality Assurance", text: "Rigorous inspections at every milestone ensure each detail meets our exacting standards." },
  { step: "06", title: "Project Completion", text: "Final finishes, defect resolution, and a comprehensive review before we consider the work complete." },
  { step: "07", title: "Handover", text: "We hand over a finished project you're proud of, along with the documentation and support you need." },
];

export const STATS = [
  { value: 5, suffix: "+", label: "Years of Experience" },
  { value: 40, suffix: "+", label: "Projects Delivered" },
  { value: 100, suffix: "%", label: "Client Commitment" },
  { value: 2, suffix: "", label: "States Serviced" },
];

export const CERTIFICATIONS = [
  { title: "Fully Insured", text: "Comprehensive coverage protecting every project and stakeholder." },
  { title: "Licensed Builder", text: "Registered and licensed to build across our service areas." },
  { title: "OH&S Compliant", text: "Occupational health and safety embedded into every site." },
  { title: "Australian Standards", text: "Every build meets or exceeds relevant Australian Standards." },
  { title: "Quality Assurance", text: "Documented quality control from planning to handover." },
];

export const AREAS = {
  victoria: [
    "Melbourne", "Craigieburn", "Mickleham", "Greenvale", "Donnybrook", "Epping",
    "Kalkallo", "Roxburgh Park", "Broadmeadows", "Sunbury", "Tarneit", "Wallan",
    "Beveridge", "Mernda", "South Morang", "Regional Victoria",
  ],
  southAustralia: [
    "Adelaide", "Pooraka", "Mawson Lakes", "Salisbury", "Parafield", "Prospect",
    "Modbury", "Golden Grove", "Elizabeth", "Gawler", "Playford", "Tea Tree Gully",
    "Northern Adelaide",
  ],
};

export const FAQS = [
  {
    q: "What areas do you service?",
    a: "We operate across Victoria and South Australia, including Melbourne, Craigieburn, Sunbury, Tarneit and regional Victoria, as well as Adelaide, Pooraka, Salisbury, Golden Grove and northern Adelaide.",
  },
  {
    q: "What types of projects do you undertake?",
    a: "We deliver residential construction, renovations and extensions, and full design and project management services — tailored to each client's vision.",
  },
  {
    q: "How do you ensure projects stay on time and on budget?",
    a: "Our disciplined project management and transparent fixed-scope quotations mean efficient delivery without compromising workmanship. We keep you informed at every stage.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Kotam Projects is a licensed builder, fully insured, OH&S compliant, and every build meets relevant Australian Standards.",
  },
  {
    q: "How do you approach safety on site?",
    a: "Safety is part of our culture. We maintain safe work environments through proactive planning, ongoing training, strict compliance with Australian safety regulations, and continuous risk management.",
  },
  {
    q: "How do I request a quote?",
    a: "Simply use our enquiry form on the Contact page, or call us on 0478 900 097. We'll arrange a consultation to understand your project and provide a transparent quotation.",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Our Process", to: "/process" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];
